"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AccordionBlock_1 = require("./components/AccordionBlock");
var Accordion = function (_a) {
    var data = _a.data, name = _a.name, options = _a.options, events = _a.events, testId = _a.testId;
    var initIsOpenArr = data.map(function (item) { return item.options !== undefined && item.options.isOpen === true; });
    var _b = __read(React.useState({
        hideFocus: true,
        isClosed: initIsOpenArr.indexOf(false) !== -1,
        isExpandAll: initIsOpenArr.indexOf(false) !== -1,
        isOpen: initIsOpenArr.indexOf(false) === -1,
        isOpenArr: initIsOpenArr,
    }), 2), state = _b[0], setState = _b[1];
    React.useEffect(function () {
        setState(__assign(__assign({}, state), { isOpenArr: initIsOpenArr }));
    }, [data]);
    var isClosed = state.isClosed, isExpandAll = state.isExpandAll, isOpen = state.isOpen;
    var toggleExpandAll = function (e) {
        var updtState = true;
        if (e.key) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.stopPropagation();
                e.preventDefault();
            }
            else {
                updtState = false;
            }
        }
        if (updtState) {
            setState(__assign(__assign({}, state), { isClosed: !isClosed && !isExpandAll, isExpandAll: isClosed && !isOpen, isOpen: !isOpen && isExpandAll }));
            if (events && events.onExpandAll) {
                events.onExpandAll(isClosed && !isOpen);
            }
        }
    };
    var staticDataToPass = {
        setState: setState,
        state: state,
        withExpand: options && options.withExpand ? true : false,
    };
    return (React.createElement("div", { className: "align-items-center flex flex-column text-center", "data-testid": testId },
        options && options.title && (React.createElement("h2", { className: options && options.titleClassName
                ? options.titleClassName
                : "heading-xxxl mar-b-md" }, options.title)),
        options && options.withExpand && (React.createElement("div", { className: "flex " + (options && options.expandAlignment === "right"
                ? "justify-end"
                : "justify-center") + (options && options.expandBtnClassName
                ? " " + options.expandBtnClassName
                : " mar-b-xl") },
            React.createElement("a", { className: "link-text3 solo", onClick: toggleExpandAll, onKeyDown: toggleExpandAll, tabIndex: 0, role: "button" }, isExpandAll ? "Expand all" : "Collapse all"))),
        React.createElement("div", { className: "border-top border-light-gray" }, data.map(function (item, index) {
            var childData = item.data, itemProps = item.options;
            var newOptions = __assign(__assign({}, itemProps), { index: index, paddingType: options && options.paddingType ? options.paddingType : "medium" });
            return (React.createElement(AccordionBlock_1.default, { events: events, data: childData, options: __assign(__assign({}, newOptions), staticDataToPass), testId: name, key: index }));
        }))));
};
exports.default = Accordion;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Accordion/Accordion.js
// module id = 1737
// module chunks = 8